/**
 * Tamanho de arquivo legível.
 *
 * Fica em `lib` porque é usado nas duas pontas do mesmo arquivo: a prévia do que
 * está em espera no compositor e a bolha do que já foi enviado. Duas cópias
 * divergiriam no arredondamento, e o mesmo PDF apareceria como "1.2 MB" antes de
 * sair e "1,2 MB" depois.
 */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
